import { computed, type ComputedRef } from 'vue'

import { useWorkflowInWorkviewStore } from '@/modules/Workview/useWorkflowInWorkviewStore'
import { V2InstanceStatus } from '@/store/types'

import useHasNoWorkflow from './useHasNoWorkflow'

export default (): ComputedRef<boolean> => {
  const workflowInWorkviewStore = useWorkflowInWorkviewStore()
  const { hasNoWorkflow } = useHasNoWorkflow()

  const isCurrent = computed(
    () => workflowInWorkviewStore.selectedStageInstance?.status === V2InstanceStatus.Current,
  )

  const isTimeTravelling = computed(() => !hasNoWorkflow.value && !isCurrent.value)

  return isTimeTravelling
}
